import React from 'react';
import CreateIcon from '@material-ui/icons/Create';
import { useTheme, makeStyles } from '@material-ui/core';

const styles = makeStyles(() => ({
  icon: {
    fontSize: '16px',
  },
}));

const EditIcon = () => {
  const classes = styles();
  const { primary } = useTheme().palette;
  return <CreateIcon htmlColor={primary.main} className={classes.icon} data-testid="editIcon" />;
};

export default EditIcon;
